<template>
  <!-- <v-layout column wrap > -->
    <v-dialog v-model="dialogcreate_company" max-width="500px" persistent max-height="500px" style="overflow-y: hidden; border-radius: 20px !important;" class="Kanit">

   <v-card class="Kanit">
      <v-card tile>

        <v-toolbar dark class="toolbarcreatedadmin">
          <v-toolbar-title v-if="typeCompany === 'owner'">สร้าง หน่วยงานในเครือสภากาชาด</v-toolbar-title>
          <v-toolbar-title v-else-if="typeCompany === 'partner'">สร้าง หน่วยงานร่วมโครงการ</v-toolbar-title>
          <v-toolbar-title v-else>สร้าง หน่วยงานบำรุงรักษาเครื่อง AED</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn dark icon @click="closeDialog">
            <v-icon style="color: white !important; font-size: 20px !important;">clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card>
      <v-card-text style="height: 380px !important; overflow-y: auto; margin-top: 20px;">
        <!-- <v-layout row wrap justify-center align-center> -->
          <div>
            <h3 v-if="typeCompanyDecode == 'partner'" style="color: black;text-align: left;margin-bottom: 5px;">
              <!-- ดูแลเครื่องของหน่วยงาน: {{nameCompany}} -->
            </h3>
            <v-select
            :items="listHeade_company"
            item-text="company_name"
            item-value="company_id"
            v-model="headcom_id"
            label="เลือกหน่วยงานสังกัดอยู่"
            outlined
            hide-details
            single-line
            style="margin-bottom: 10px;"
            v-else-if="typeCompany === 'maintenance'"
            :menu-props="{ bottom: true, offsetY: true }"
          ></v-select>
          <v-text-field
            label="ชื่อหน่วยงาน"
            single-line
            outlined
            hide-details
            v-model="company_name"
            class="textfieldInput"
            style="margin-bottom: 10px;"
          ></v-text-field>

          <v-textarea
            outlined
            single-line
            no-resize
            hide-details
            label="รายละเอียด"
            value=""
            v-model="company_detail"
            style="margin-bottom: 10px;"
          ></v-textarea>

        </div>
        <v-btn rounded color="#a80f00" style="margin-top: 10px;text-transform: none; color: white;" 
        :disabled="company_name == '' || headcom_id == ''" @click="createCompany" v-if="typeCompany=='maintenance'">สร้าง</v-btn>
        <v-btn rounded color="#a80f00" style="margin-top: 10px;text-transform: none; color: white;" 
        :disabled="company_name == ''" v-else @click="createCompany">สร้าง</v-btn>
        
      </v-card-text>
    </v-card>
  <!-- </v-layout> -->

</v-dialog>
</template>
<script>
import { Decode } from '@/services'
export default {
  props: {
    dialogcreate_company: false,
    typeCompany: '',
    headid: ''
  },
  data: () => ({
    BASE_URL: process.env.BASE_URL,
    username: '',
    password: '',
    phoneRules: [
      v => (!!v && v.length === 10) || 'กรุณากรอกตัวเลขให้ครบ 10 หลัก',
      v => !!v || 'กรุณากรอกข้อมูลเป็นตัวเลข',
      v => /^0[0-9]{9}/.test(v) || 'รูปแบบหมายเลขโทรศัพท์ไม่ถูกต้อง'
    ],
    emailRules: [
      v => !v || (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v)) || 'รูปแบบอีเมลไม่ถูกต้อง'
    ],
    company_address: '',
    company_name: '',
    company_detail: '',
    company_email: '',
    company_tell: '',
    checkbox1: false,
    checkbox2: false,
    listHeade_company: [],
    textType_company: 'หน่วยงานในเครือสภากาชาด',
    headcom_id: '',
    idCompany: '',
    typeCompanyDecode: '',
    nameCompany: ''
  }),
  created () {
    this.typeCompanyDecode = this.$store.state.key_object.typeCompany
    this.idCompany = this.$store.state.key_object.idCompany
    this.nameCompany = this.$store.state.key_object.nameCompany
    this.headcom_id = this.idCompany
    if (this.typeCompany === 'maintenance') {
      this.textType_company = 'หน่วยงานบำรุงรักษาเครื่อง AED'
    } else if (this.typeCompany === 'redcross') {
      this.textType_company = 'หน่วยงานในเครือสภากาชาด'
    } else if (this.typeCompany === 'partner') {
      this.textType_company = 'หน่วยงานร่วมโครงการ'
    }
    this.changeType()
    if (this.typeCompanyDecode === 'owner') {
      this.getComapny()
    }
  },
  watch: {
    headid () {
      this.headcom_id = this.headid
    },
    typeCompany () {
      this.changeType()
    }
  },
  methods: {
    changeType () {
      if (this.typeCompany === 'maintenance') {
        this.textType_company = 'หน่วยงานบำรุงรักษาเครื่อง AED'
      } else if (this.typeCompany === 'owner') {
        this.textType_company = 'หน่วยงานในเครือสภากาชาด'
      } else if (this.typeCompany === 'partner') {
        this.textType_company = 'หน่วยงานร่วมโครงการ'
      }
    },
    closeDialog () {
      this.company_name = ''
      this.company_detail = ''
      this.headcom_id = ''
      this.$emit('closecreate_company', false)
    },
    createCompany () {
      if (this.typeCompany === 'maintenance') {
        var body = {
          company_name: this.company_name,
          company_detail: this.company_detail,
          company_type: this.typeCompany,
          company_head: this.headcom_id
        }
      } else {
        var body = {
          company_name: this.company_name,
          company_detail: this.company_detail,
          company_type: this.typeCompany
        }
      }
      
      this.$api.createCompany(body).then((response) => {
        if (response.data.message === 'success') {
          this.$swal( 'สำเร็จ', 'สร้าง' + this.textType_company + 'สำเร็จแล้ว' , 'success' )
          this.closeDialog()
        } else if (response.data.message === 'companyname_is_already') {
          this.$swal( 'ไม่สำเร็จ', 'ชื่อ ' + this.textType_company + 'มีในระบบแล้ว', 'error' )
        } else {
          this.$swal( 'ไม่สำเร็จ', 'สร้าง' + this.textType_company + 'ไม่สำเร็จแล้ว', 'error' )
          this.closeDialog()
        }
      })
    },
    getComapny () {
      this.$api.getAllCompany().then((response) => {
        if (response.data.message === 'success') {
          this.listHeade_company = _.reject(response.data.data, ['company_type', 'maintenance'])
        }
      })
    },
    btncancle () {
      this.username = ''
      this.password = ''
      this.company_name = ''
      this.company_address = ''
      this.company_email = ''
      this.company_tell = ''
      this.checkbox1 = false
      this.checkbox2 = false
    }
  }
}
</script>
<style media="screen" scoped>
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
>>>.v-textarea.v-text-field--enclosed.v-text-field--single-line .v-label {
  top: 10px !important;
}
>>>.v-list-item .v-list-item__title {
    font-family: 'Kanit', sans-serif !important;

}
.inputinfor_address {
  height: 110px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: white !important;
}
.inputinfor_dis {
  height: 50px !important;
  border-width: thin !important;
  border-style: solid !important;
  border-color: #a80e00 !important;
  border-radius: 7px !important;
  background-color: #FAF0F0 !important;
}
>>>.layout.wrap {
  flex-wrap: wrap;
}
>>>.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}
.toolbarcreatedadmin {
  border-top-color: transparent !important;
  border-left-color: transparent !important;
  border-width: thin !important;
  border-right-color: transparent !important;
  border-style: solid !important;
  height: 64px !important;
  border-left-style: initial !important;
  border-right-style: initial !important;
  border-radius: 0px !important;
  border-bottom-color: #a80e00 !important;
  background-color: #a80e00 !important;
  color: white !important;
  border-width: thin !important;
  box-shadow: none !important;
}
/* >>>.v-input__slot {
  border-radius: 10px !important;
  border-style: solid !important;
  border-width: thin !important;
  border-color: #a80f00 !important;
  background-color: #a80d0021 !important;
} */
.btngen {
  background-color: white !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
  width: 120px !important;
}
.btncreateuser {
  background-color: #a80f00 !important;
  color: #fafafa !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  text-transform: none !important;
}
.btncreateuser:disabled {
  background-color: #a80f0099 !important;
  color: #fafafa9c !important;
  border-color: #a80f0091 !important;
  border-style: solid !important;
  border-width: thin !important;
}

.btncancle {
  background-color: #fafafa !important;
  color: #a80f00 !important;
  border-color: #a80f00 !important;
  border-style: solid !important;
  border-width: thin !important;
  width: 160px !important;
}
>>>.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
  background-color: #a80f0099 !important;
  color: #fafafa9c !important;
  border-color: #a80f0091 !important;
  border-style: solid !important;
  border-width: thin !important;
}


>>>.v-input .v-label {
    height: 30px;
    line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/create/create_company_modal.vue